import styled from 'styled-components';
import { useLayoutContext } from '../../LayoutContext';
import { getRenderSidebarCollapsed } from '../animationCore';
import Footer from './Footer';
import Header from './Header';
import { Main } from './Main';
import { SidebarModeControlButtonClass } from './SidebarModeControlButton';

const StyledSidebar = styled.section`
  overflow: auto;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: auto 1fr auto;
  grid-column-gap: 0;
  grid-row-gap: 2px;
  align-items: stretch;

  background-color: ${({ theme }) => theme?.colors?.gray?._25};
  border-right: 1px solid ${(props) => props.theme?.colors?.gray?._200};

  .${SidebarModeControlButtonClass} {
    visibility: hidden;
  }

  &:hover {
    .${SidebarModeControlButtonClass} {
      visibility: initial;
    }
  }
`;

const StyledSection = styled.section<{ collapsed: boolean }>`
  overflow: auto;
  display: flex;
  flex-direction: column;
  align-items: ${({ collapsed }) => collapsed && 'center'};
  padding: 0 ${({ theme, collapsed }) => (collapsed ? 0 : theme?.spacing?.md)};
`;

// Warning: changing the internal spacing of the elements of this component
// directly affects the sidebar animation
// e.g. changing the left or right padding/margin values
function LayoutDefaultSidebar() {
  const { sidebarCollapsed, sidebarTransitionEnded } = useLayoutContext();
  const renderSidebarCollapsed = getRenderSidebarCollapsed(
    sidebarCollapsed,
    sidebarTransitionEnded,
  );
  return (
    <StyledSidebar>
      <StyledSection collapsed={renderSidebarCollapsed}>
        <Header collapsed={renderSidebarCollapsed} />
      </StyledSection>
      <StyledSection collapsed={renderSidebarCollapsed}>
        <Main />
      </StyledSection>
      <StyledSection collapsed={renderSidebarCollapsed}>
        <Footer />
      </StyledSection>
    </StyledSidebar>
  );
}

export default LayoutDefaultSidebar;
